import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../../../utils/constants';

interface Props {
  currentDepth: number;
  voteCount: number;
}

export const UpVote = ({ currentDepth, voteCount }: Props) => {
  // TODO add mutation to upvote

  if (currentDepth !== 1) return null;

  return (
    <div css={upvoteSectionStyles}>
      <button css={upvoteButtonStyles} aria-label="Upvote" type="button">
        ▲
      </button>
      <div css={voteCountStyles}>{voteCount}</div>
    </div>
  );
};

const upvoteSectionStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginRight: '16px',
  minWidth: '40px',
  [MOBILE.MEDIA_QUERY]: {
    marginRight: '8px',
    minWidth: '32px',
  },
});

const upvoteButtonStyles = css({
  background: token('color.background.neutral'),
  border: `1px solid ${token('color.border')}`,
  color: token('color.text.subtle'),
  fontSize: '16px',
  cursor: 'pointer',
  padding: '2px 6px',
  borderRadius: '4px',
  marginBottom: '4px',
  transition: 'color 0.2s, background 0.2s, border 0.2s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    color: token('color.background.brand.bold'),
    background: token('color.background.input.hovered'),
    border: `1px solid ${token('color.background.brand.bold')}`,
  },
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '14px',
    padding: '1px 4px',
  },
});

const voteCountStyles = css({
  fontWeight: 600,
  fontSize: '15px',
  color: token('color.text.subtle'),
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '13px',
  },
});
